import React, { useContext } from 'react';
import Isvg from 'react-inlinesvg';
import PropTypes from 'prop-types';

import Message from 'components/Message';
import When from 'components/When';
import { ICONS } from 'constants/icons';
import LINKS from 'constants/links';
import { bem } from 'helpers/class-name';

import CookiesContext, { CONSENT_MODELS } from '../CookiesContext';

import { messages } from './PrivacyFooter.messages';

import './PrivacyFooter.scss';

const { block, element } = bem('privacy-footer');

function PrivacyFooter({ standardTermsUrl }) {
  const { consentModel, openModal: openCookieModal, openYourPrivacyChoicesModal } = useContext(CookiesContext);
  const isCCPALike = consentModel === CONSENT_MODELS.CCPA_RULES;

  const baseItems = [
    { message: messages.termsAndConditions, link: standardTermsUrl },
    { message: messages.privacyPolicy, link: LINKS.privacyPolicy.href },
    { message: messages.cookieSettings, action: openCookieModal },
  ];

  const californiaPrivacyChoicesItem = {
    message: messages.yourPrivacyChoices,
    action: openYourPrivacyChoicesModal,
    icon: ICONS.californiaPrivacyChoices,
  };

  const items = isCCPALike ? [...baseItems, californiaPrivacyChoicesItem] : baseItems;

  return (
    <footer className={block()}>
      {items.map(({ message, action, link, icon }, index) => (
        <React.Fragment key={message.id}>
          <a
            key={`${message.id}-item`}
            href={link}
            target="_blank"
            rel="noreferrer noopener"
            onClick={action}
            role={link ? 'link' : 'button'}
            className={element('link')}
            data-testid="privacy-footer-actionable-item">
            {icon && <Isvg src={icon} className={element('link-icon')} />}
            <Message message={message} />
          </a>
          <When key={`${message.id}-divider`} predicate={index < items.length - 1}>
            <div className={element('divisor')} />
          </When>
        </React.Fragment>
      ))}
    </footer>
  );
}

PrivacyFooter.propTypes = {
  standardTermsUrl: PropTypes.string,
};

export default PrivacyFooter;
